<template>
  <AttendanceDialog v-if="confirmAttendance" v-model:open="open" gap :context="attendanceContext" />
  <AppDialog
    v-else-if="assessment.action === FLUID_ACTION.SYMPTOMS"
    v-model:open="open"
    :title="t('nkf.followup.title')"
    :description="t('nkf.followup.question')"
  >
    <template #illustration
      ><span
        class="symptom-prompt-icon tw:grid tw:place-items-center tw:text-(--violet) tw:bg-(--violet-soft) tw:mt-3 tw:mx-auto tw:mb-0 tw:w-16 tw:h-16 tw:rounded-(--radius-card)"
        ><Activity class="tw:icon-dialog" /></span
    ></template>
    <template #footer
      ><div class="field-row">
        <Button @click="recordSymptoms"
          ><Check class="tw:icon-action" />{{ t('nkf.interactions.yes') }}</Button
        ><Button
          variant="outline"
          class="tw:text-(--result-high) tw:border-(--destructive-border)"
          @click="noSymptoms"
          ><X class="tw:icon-action" />{{ t('nkf.interactions.no') }}</Button
        >
      </div></template
    >
  </AppDialog>
  <IdwgAlertDialog
    v-else-if="assessment.action === FLUID_ACTION.ALERT"
    v-model:open="alertOpen"
    :context="reading"
    @dismissed="afterDismissal"
  />
</template>
<script setup>
// 1. Import necessary components
import { computed, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { Activity, Check, X } from '@lucide/vue';
import AppDialog from '@/shared/components/AppDialog.vue';
import { Button } from '@/shared/components/ui/button';
import IdwgAlertDialog from './IdwgAlertDialog.vue';
import AttendanceDialog from './AttendanceDialog.vue';
import { FLUID_ACTION } from '../constants/reading';
// 2. Use
const open = defineModel('open', { type: Boolean, default: false });
const props = defineProps({ reading: { type: Object, required: true } });
const { t } = useI18n();
const router = useRouter();
// 3. Define a reactive variable
const confirmAttendance = shallowRef(false);
const attendanceContext = shallowRef(null);
// 4. Define methods or computed properties if needed
const alertOpen = computed({
  get: () => open.value && !confirmAttendance.value,
  set: (value) => {
    if (!value && !confirmAttendance.value) {
      open.value = false;
    }
  },
});
const assessment = computed(() => props.reading.followUp ?? props.reading.dashboard.assessment);
function afterDismissal(dashboard) {
  attendanceContext.value = { ...props.reading, dashboard };
  confirmAttendance.value = dashboard.attendance.gapQuestionDue;
}
function noSymptoms() {
  open.value = false;
}
function recordSymptoms() {
  open.value = false;
  return router.push('/symptoms');
}
// 5. VueJS Hooks
</script>
